import { Pipe, PipeTransform, inject } from '@angular/core';
import { FormattingOverrides } from '@zag/core/common';
import { FormattingService } from './formatting.service';

/**
 * Formats a numeric value as currency using the active locale and tenant currency code.
 *
 * Usage:
 * ```html
 * {{ totalCost | zagCurrency }}
 * {{ totalCost | zagCurrency : { currency: 'EUR' } }}
 * ```
 */
@Pipe({
  name: 'zagCurrency',
  pure: false,
})
export class ZagCurrencyPipe implements PipeTransform {
  private readonly formattingService = inject(FormattingService);

  transform(value: number | null | undefined, overrides?: FormattingOverrides): string {
    if (value == null) {
      return '';
    }
    return this.formattingService.formatCurrency(value, overrides);
  }
}
